/**
 * Utility functions for subscription management
 */

/**
 * Check if a subscription is CAS-only (seo_optimization enabled, others disabled)
 * @param {Object} subscription - The subscription object
 * @returns {boolean} - True if CAS-only subscription
 */
export const isCASOnlySubscription = (subscription) => {
    const features = subscription?.plan?.features;
    return features?.seo_optimization === true &&
        features?.website_creation === false &&
        features?.content_generation === false &&
        features?.image_creation === false &&
        features?.blog_generation === false;
};

/**
 * Get available operations for a subscription
 * @param {Object} subscription - The subscription object
 * @returns {Array} - Array of available operation names
 */
export const getAvailableOperations = (subscription) => {
    if (isCASOnlySubscription(subscription)) {
        return []; // No main content operations for CAS-only
    }
    return ['generate_images', 'generate_blogs', 'generate_pages', 'create_website'];
};

/**
 * Check if operations should be shown for a subscription
 * @param {Object} subscription - The subscription object
 * @returns {boolean} - True if operations should be shown
 */
export const shouldShowOperations = (subscription) => {
    return !isCASOnlySubscription(subscription);
}; 